import * as React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { useTranslation } from '@lib/useTypedTranslation';
import { Card } from '@components/card/card';
import { TabPanel } from '@components/tabs/tab-panel';
import { LinkTab } from '@components/tabs/link-tab';

import { useFeatureTogglesContext } from '../../../context/featureToggles';
import { useWorldRoutes } from '../../../routes/parts/allWorldRoutes';
import { ProcessCrashes } from '../processes/compositions/processCrashes';
import { ProcessesList } from '../processes/compositions/processesList';

import './coreProcessesHub.css';

export const CoreProcessesHub = () => {
  const { t } = useTranslation(['translation', 'coreProcesses']);
  const routes = useWorldRoutes();
  const { showProcessesTabs } = useFeatureTogglesContext();
  const onCrashesTab = Boolean(useRouteMatch(routes.core.processesCrashes));

  return (
    <div data-id="core-processes">
      <Card className="core-processes-hub" noPadding>
        {/* Keyed by the toggle so that, were it to change, the panel is rebuilt rather than holding on to the selected index
            (and rendered content) of a tab which no longer exists. Navigating between tabs doesn't change the key. */}
        <TabPanel key={String(showProcessesTabs)} defaultTabIndex={showProcessesTabs && onCrashesTab ? 1 : 0} enableStatePreservation tabAlignment="start">
          <LinkTab id="processes" title={t('PROCESSES', { ns: 'translation' })} link={routes.core.processesList}>
            <ProcessesList />
          </LinkTab>
          {showProcessesTabs && <LinkTab id="crashes" title={t('CRASHES', { ns: 'coreProcesses' })} link={routes.core.processesCrashes}>
            <ProcessCrashes />
          </LinkTab>}
        </TabPanel>
      </Card>
    </div>
  );
};
